import React from "react";
import {
  CameraVideoFill,
  CameraVideoOffFill,
  MicFill,
  MicMuteFill,
} from "react-bootstrap-icons";
import { classNames } from "../../../../general/functions/propsComponent";

export default function VideoControl(props) {
  const { setMute, tracksState } = props;
  const mute = async (type) => {
    if (type === "audio") {
      setMute({ type: "audio", status: !tracksState.audio });
    } else if (type === "video") {
      setMute({ type: "video", status: !tracksState.video });
    }
  };

  return (
    <div className="flex gap-2">
      <button
        className={classNames(
          tracksState.audio ? "on" : "",
          "btn-secondary p-2 w-16 flex flex-col justify-center items-center"
        )}
        onClick={() => mute("audio")}
      >
        {tracksState?.audio ? (
          <MicFill size={16} />
        ) : (
          <MicMuteFill size={16} className="text-red-500" />
        )}{" "}
        {/* <p className="text-xs font-normal">Mic</p> */}
      </button>

      <button
        className={classNames(
          tracksState.video ? "on" : "",
          "btn-secondary p-2 w-16 flex flex-col justify-center items-center"
        )}
        onClick={() => mute("video")}
      >
        {tracksState?.video ? (
          <CameraVideoFill size={16} />
        ) : (
          <CameraVideoOffFill size={16} className="text-red-500" />
        )}{" "}
        {/* <p className="text-xs font-normal">Cam</p> */}
      </button>
    </div>
  );
}
